export default function AMCommonGenericCountdown(selector) {
  const SELECTOR_COUNTDOWN_DAYS_ELEMENT = `${selector}__countdown-days`;
  const SELECTOR_COUNTDOWN_HOURS_ELEMENT = `${selector}__countdown-hours`;
  const SELECTOR_COUNTDOWN_MINUTES_ELEMENT = `${selector}__countdown-minutes`;
  const SELECTOR_COUNTDOWN_SECONDS_ELEMENT = `${selector}__countdown-seconds`;

  let endsAtTimestamp;
  let intervalId;
  let $countdown;
  let $countdownDaysElement;
  let $countdownHoursElement;
  let $countdownMinutesElement;
  let $countdownSecondsElement;

  this.initiate = () => {
    $countdown = $(selector);

    if (!$countdown.length) {
      return;
    }

    endsAtTimestamp = parseInt($countdown.data('ends') || 0, 10);

    if (!endsAtTimestamp) {
      return;
    }

    this.initializeCountdownTimer();
  };

  this.refreshCountdown = () => {
    const currentTimestampInSeconds = Date.now() / 1000;
    const remainingTimeInSeconds = endsAtTimestamp - currentTimestampInSeconds;

    if (remainingTimeInSeconds <= 0) {
      clearInterval(intervalId);

      $countdown.remove();

      return;
    }

    const secondsInAMinute = 60;
    const secondsInAnHour = 60 * secondsInAMinute;
    const secondsInADay = 24 * secondsInAnHour;

    // extract days
    const days = Math.floor(remainingTimeInSeconds / secondsInADay);

    // extract hours
    const hourSeconds = remainingTimeInSeconds % secondsInADay;
    const hours = Math.floor(hourSeconds / secondsInAnHour);

    // extract minutes
    const minuteSeconds = hourSeconds % secondsInAnHour;
    const minutes = Math.floor(minuteSeconds / secondsInAMinute);

    // extract the remaining seconds
    const remainingSeconds = minuteSeconds % secondsInAMinute;
    const seconds = Math.ceil(remainingSeconds);

    $countdownDaysElement.text(days);
    $countdownHoursElement.text(hours);
    $countdownMinutesElement.text(minutes);
    $countdownSecondsElement.text(seconds);
  };

  this.initializeCountdownTimer = () => {
    $countdownDaysElement = $countdown.find(SELECTOR_COUNTDOWN_DAYS_ELEMENT);
    $countdownHoursElement = $countdown.find(SELECTOR_COUNTDOWN_HOURS_ELEMENT);
    $countdownMinutesElement = $countdown.find(SELECTOR_COUNTDOWN_MINUTES_ELEMENT);
    $countdownSecondsElement = $countdown.find(SELECTOR_COUNTDOWN_SECONDS_ELEMENT);

    if (
      !$countdownDaysElement.length
      || !$countdownHoursElement.length
      || !$countdownMinutesElement.length
      || !$countdownSecondsElement.length
    ) {
      return;
    }

    intervalId = setInterval(this.refreshCountdown, 1000);
  };
}
